import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { initUserState } from '@vip-activity/business';
import { mapActions } from 'vuex';
import MagicService from '@/service/magic';
import activePage from './active-page/active-page.vue';
import laiseeControl from './laisee-control/laisee-control.vue';
import popProcess from './pop-process/pop-process.vue';
import popDanger from './pop-danger/pop-danger.vue';
import popBeltArrived from './pop-belt-arrived/pop-belt-arrived.vue';
import popMoreRed from './pop-more-red/pop-more-red.vue';
import popLuckyArrived from './pop-lucky-arrived/pop-lucky-arrived.vue';
import loginAccount from './login-account/login-account.vue';
import popRules from './pop-rules/pop-rules.vue';
export default {
  components: {
    activePage: activePage,
    laiseeControl: laiseeControl,
    popProcess: popProcess,
    popDanger: popDanger,
    popBeltArrived: popBeltArrived,
    popMoreRed: popMoreRed,
    popLuckyArrived: popLuckyArrived,
    loginAccount: loginAccount,
    popRules: popRules
  },
  data: function data() {
    return {
      showHistory: false,
      isShowHistory: false,
      showDanger: false,
      showLucky: false,
      isCloseShowAccount: false,
      hideBelt: false,
      shouldGetLottery: false,
      showBeltOnly: false,
      showRule: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    getNow: 'getNow'
  })), {}, {
    getLottery: function getLottery() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.debug('getLottery');
                _context.prev = 1;
                _context.next = 4;
                return _this.$store.dispatch('refreshLotteryInfo');

              case 4:
                if (!(_this.remainNum > 0)) {
                  _context.next = 24;
                  break;
                }

                _this.$report.expose(_this.reportData.福袋查询.可以抽奖);

                console.log('可以抽奖');
                _context.prev = 7;
                _context.next = 10;
                return MagicService.lottery();

              case 10:
                res = _context.sent;

                if (res.ret === 0 && res.data) {
                  _this.setState({
                    state: 'magicInfo',
                    value: res
                  });
                }

                _context.next = 21;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                console.log(_context.t0);

                if (!(_context.t0.code === -905)) {
                  _context.next = 20;
                  break;
                }

                _this.showDanger = true;
                return _context.abrupt("return");

              case 20:
                if (_context.t0.res) {
                  _this.setState({
                    state: 'magicInfo',
                    value: _context.t0.res
                  });
                }

              case 21:
                _this.showLucky = true;
                _context.next = 25;
                break;

              case 24:
                _this.$report.expose(_this.reportData.福袋查询.不可以抽奖);

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](1);

                _this.$report.expose(_this.reportData.福袋查询.查询失败);

                _this.toast("".concat(_context.t1.msg || '查询福袋失败'));

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 27], [7, 14]]);
      }))();
    },
    refreshList: function refreshList() {
      this.$store.dispatch('getLotteryList');
    }
  }),
  computed: {
    showAccount: function showAccount() {
      return this.isLogin && !this.isCloseShowAccount && this.vuid !== this.tenvideoVuid && this.tenvideoVuid !== '';
    },
    showGetBelt: function showGetBelt() {
      return this.firstgetGoldBelt && this.tenvideoVuid === this.vuid && !this.showAccount && !this.hideBelt && this.from === 'task';
    },
    showGetBeltOnly: function showGetBeltOnly() {
      return this.showBeltOnly && this.hasGoldBelt;
    }
  },
  created: function created() {
    var _this2 = this;

    // this.bindEvent()
    this.getNow();
    this.$store.dispatch('getAppInstall');
    this.$store.dispatch('getLotteryFlowList');
    this.eventBus.$on('showHistory', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(isShowHistory) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading.show();

                _context2.next = 3;
                return _this2.updateFetcherList(true);

              case 3:
                _this2.loading.hide();

                _this2.getLottery();

                console.log('isShowHistory', isShowHistory);
                _this2.showHistory = true;
                _this2.isShowHistory = isShowHistory;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    this.eventBus.$on('dailyAddFinish', function () {
      _this2.showBeltOnly = true;
    });
    this.eventBus.$on('showDanger', function () {
      _this2.showDanger = true;
    });
    this.eventBus.$on('showRule', function () {
      console.log('showRule');
      _this2.showRule = true;
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this3.isEnd) {
                _this3.alert({
                  msg: window.timeSetting.提示,
                  confirmText: window.timeSetting.按钮文案,
                  confirm: function confirm() {
                    window.location.href = window.timeSetting.链接;
                  }
                });
              }

              _context3.next = 3;
              return initUserState();

            case 3:
              _this3.$report.ready();

              aegis.reportInteractive();

              try {
                if (!_this3.isEnd && _this3.isLogin) {
                  _this3.$store.dispatch('dailyAdd');
                }
              } catch (e) {
                console.log(e);
              }

              try {
                if (_this3.isLogin) {
                  _this3.$store.dispatch('getLotteryList');
                }
              } catch (e) {
                _this3.toast('获取历史福袋信息失败,请稍后再试');

                console.error(e);
              }

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};